const ModalHandler = (stateModal, setModal, onClose) => {
  return {
    handleClose: () => {
      setModal("isOpen", false);
      if (onClose) {
        onClose();
      }
    },

    handleBackdropClick: () => {
      setModal("isOpen", false);
      if (onClose) {
        onClose();
      }
    },

    handleEscKey: (event) => {
      if (event.key === "Escape" && stateModal.isOpen) {
        setModal("isOpen", false);
        if (onClose) {
          onClose();
        }
      }
    },
  };
};

export default ModalHandler;
